import { render } from "./Index.vue?vue&type=template&id=63621004"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/CGU/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63621004"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63621004', __exports__)) {
    api.reload('63621004', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=63621004", () => {
    api.rerender('63621004', render)
  })

}


export default __exports__